export const objectRelationValue = (relationKind, objectId) => ({
    _object: objectId,
    _relationKind: relationKind,
});
export const profileRelationValue = (profileId) => ({
    _object: profileId,
    _relationKind: 'profile',
});
//# sourceMappingURL=relations.js.map